export enum EPage {
    Home = 'Home',
    PaymentProfile = 'PaymentProfile',
    MyBills = 'MyBills',
    BillingAndPayments = 'BillingAndPayments',
    Unauthorized = 'Unauthorized',
}

export type PageContentDetails = {
    pageHeading: string;
    pageDescription?: string;
    contentHeading: string;
};

type TPageContent = {
    [key in EPage]?: PageContentDetails;
};

function getPageContentMapping(): TPageContent {
    return {
        [EPage.MyBills]: {
            pageHeading: 'My bills',
            contentHeading: 'You will need administrator access to see this page',
        },
        [EPage.PaymentProfile]: {
            pageHeading: 'Payment details',
            pageDescription: '',
            contentHeading: 'You will need administrator access to see this page',
        },
        [EPage.BillingAndPayments]: {
            pageHeading: 'Billing and payments',
            pageDescription: 'Manage payment details and bills for your subscriptions and purchases',
            contentHeading: 'You will need administrator access to manage billing and payment details',
        },
        [EPage.Unauthorized]: {
            pageHeading: '',
            pageDescription: '',
            contentHeading: 'You will need administrator access to see this page',
        },
    };
}

export { getPageContentMapping };
